import React, { useState, useContext } from 'react';
import { Link, useNavigate } from "react-router-dom"
import BaseInput from "../UI/BaseInput";
import PrimaryButton from "../UI/PrimaryButton";
import Subtitle from "../UI/Subtitle";
import CategorySelect from "./CategorySelect";
import { FormattedMessage, useIntl } from "react-intl"
import { useFormik } from 'formik';
import * as Yup from "yup"
import axios from 'axios'
import { toast } from 'react-hot-toast'
import { Context } from '../context/LanguageWrapper';
import { TailSpin } from 'react-loader-spinner';
import { ThreeDots } from 'react-loader-spinner'
import homeLogo from '../../assets/marchetto-home.png'

let fieldEmpty = <FormattedMessage id="app.catalog.form.validation" defaultMessage="Required Field" />
const phoneRegExp = /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/
// Country Code ( i.e. +39 ) Allowed / Numbers with spaces Allowed


//const passwordRegExp = /^(?=.?[A-Z])(?=.?[a-z])(?=.?[0-9])(?=.?[#?!@$%^&-])(?!.[/\\]).{8,}$/
// At least 1 Uppercase Letter, 1 Lowercase Letter, 1 Number, 1 Special Character, 8 characters /\ not allowed



const RegisterForm = () => {

    const navigate = useNavigate();

    const context = useContext(Context)

    const [options, setOptions] = useState([]);
    const [registered, setRegistered] = useState(false);

    const [showInfo, setShowInfo] = useState(false)

    const intl = useIntl();

    const formSchema = Yup.object({
        name: Yup.string().required(fieldEmpty),
        surname: Yup.string().required(fieldEmpty),
        company: Yup.string().required(fieldEmpty),
        phone: Yup.string().matches(phoneRegExp, "Phone is not valid").required(fieldEmpty),
        position: Yup.string().required(fieldEmpty),
        email: Yup.string().email(<FormattedMessage id="app.register.formik.email" defaultMessage="Please enter a valid email" />).required(fieldEmpty),
        password: Yup.string()
            .required(fieldEmpty)
            .test('password-rules', function (value) {
                if (!value) return true;
                if (!/(?=.*[A-Z])/.test(value)) {
                    return this.createError({
                        message: intl.formatMessage({
                            id: "app.register.formik.passwordMissingUppercase",
                            defaultMessage: "Password must contain at least one uppercase letter (A–Z)."
                        })
                    });
                }
                if (!/(?=.*[a-z])/.test(value)) {
                    return this.createError({
                        message: intl.formatMessage({
                            id: "app.register.formik.passwordMissingLowercase",
                            defaultMessage: "Password must contain at least one lowercase letter (a–z)."
                        })
                    });
                }
                if (!/(?=.*\d)/.test(value)) {
                    return this.createError({
                        message: intl.formatMessage({
                            id: "app.register.formik.passwordMissingNumber",
                            defaultMessage: "Password must contain at least one number (0–9)."
                        })
                    });
                }
                if (!/(?=.*[^A-Za-z0-9])/.test(value)) {
                    return this.createError({
                        message: intl.formatMessage({
                            id: "app.register.formik.passwordMissingSpecial",
                            defaultMessage: "Password must contain at least one special character."
                        })
                    });
                }
                if (value.length < 8) {
                    return this.createError({
                        message: intl.formatMessage({
                            id: "app.register.formik.passwordMinLength",
                            defaultMessage: "Password must be at least 8 characters long."
                        })
                    });
                }
                return true;
            }),
        confirmPassword: Yup.string()
            .test('passwords-match', <FormattedMessage id="app.register.formik.passwordMatch" defaultMessage="Password and confirm password are not matching" />, function (value) {
                return this.parent.password === value;
            })
            .required(fieldEmpty)
    })

    const formik = useFormik({
        initialValues: {
            name: "",
            surname: "",
            company: "",
            email: "",
            phone: "",
            position: "",
            options: [],
            password: "",
            confirmPassword: "",
            privacy: false,
            newsletter: false,
        },
        onSubmit: (values) => {

            const formData = new FormData();

            formData.append('name', values.name)
            formData.append('surname', values.surname)
            formData.append('email', values.email)
            formData.append('company', values.company)
            formData.append('position', values.position)
            formData.append('phone', values.phone)
            formData.append('password', values.password)
            formData.append('privacy', values.privacy)
            formData.append('newsletter', values.newsletter)
            for (var i = 0; i < options.length; i++) {
                formData.append('categories[]', options[i]);
            }

            try {
                const headers = {
                    headers: {
                        "x-language": context.locale.slice(0, 2),
                    }
                };
                const data = axios.post(process.env.REACT_APP_API_ENDPOINT + `/users/register`, formData, headers)
                data.then(res => {
                    // console.log('res', res)
                    if (res['data'].status === "ok") {
                        toast.success(`Utente registrato`);
                        setRegistered(true);
                        // navigate('/app/login');
                    } else {
                        // console.log('g', res['data'].error.validation.length)
                        if (res['data'].error.validation.length === 0) {
                            toast.error(res['data'].error.message)
                        }
                        else {
                            toast.error(res['data'].error.validation['message'])
                        }
                    }
                })
            } catch (error) {
                toast.error(error)
            }
        },

        validationSchema: formSchema

    })

    const handleCategoriesChange = (values) => {
        setOptions(values);
    }

    let labelStyle = 'text-sm text-green-900 font-bold mr-1'
    let labelTextStyle = 'text-xs text-green-900 text-center'
    let labelLeftTextStyle = 'text-xs text-green-900 text-left'
    let labelTextLinkStyle = 'text-xs text-green-900 text-center underline'

    const locale = context.locale.slice(0, 2);

    return (
        <>
            {
                !registered ? (< form onSubmit={formik.handleSubmit} className="flex flex-col gap-2">
                    <Subtitle className="mb-2">
                        <FormattedMessage id="app.register.title" defaultMessage="Register" />:
                    </Subtitle>

                        <div className="flex flex-row">
                            <label className={labelStyle} htmlFor="name"><FormattedMessage id="app.register.nome" defaultMessage="Name" /></label>
                            <h1 className='text-red-600'>*</h1>
                        </div>
                    <BaseInput onChange={formik.handleChange("name")}
                        onBlur={formik.handleBlur("name")}
                        value={formik.values.name}
                        placeholder={intl.formatMessage({ id: "app.register.nome", defaultMessage: 'Name' })} />
                    <div className='text-red-400 mb-2'>
                        {formik.touched.name && formik.errors.name}
                    </div>

                        <div className="flex flex-row">
                            <label className={labelStyle} htmlFor="surname"><FormattedMessage id="app.register.surname" defaultMessage="Surname" /></label>
                            <h1 className='text-red-600'>*</h1>
                        </div>
                    <BaseInput onChange={formik.handleChange("surname")}
                        onBlur={formik.handleBlur("surname")}
                        value={formik.values.surname}
                        placeholder={intl.formatMessage({ id: "app.register.surname", defaultMessage: 'Surname' })} />
                    <div className='text-red-400 mb-2'>
                        {formik.touched.surname && formik.errors.surname}
                    </div>

                        <div className="flex flex-row">
                            <label className={labelStyle} htmlFor="company"><FormattedMessage id="app.register.company" defaultMessage="Company" /></label>
                            <h1 className='text-red-600'>*</h1>
                        </div>
                    <BaseInput onChange={formik.handleChange("company")}
                        onBlur={formik.handleBlur("company")}
                        value={formik.values.company}
                        placeholder={intl.formatMessage({ id: "app.register.company", defaultMessage: 'Company' })} />
                    <div className='text-red-400 mb-2'>
                        {formik.touched.company && formik.errors.company}
                    </div>

                        <div className="flex flex-row">
                            <label className={labelStyle} htmlFor="position"><FormattedMessage id="app.register.position" defaultMessage="Position" /></label>
                            <h1 className='text-red-600'>*</h1>
                        </div>
                    <BaseInput onChange={formik.handleChange("position")}
                        onBlur={formik.handleBlur("position")}
                        value={formik.values.position}
                        placeholder={intl.formatMessage({ id: "app.register.position", defaultMessage: 'position' })} />
                    <div className='text-red-400 mb-2'>
                        {formik.touched.position && formik.errors.position}
                    </div>

                        <div className="flex flex-row">
                            <label className={labelStyle} htmlFor="email"><FormattedMessage id="app.register.email" defaultMessage="Email" /></label>
                            <h1 className='text-red-600'>*</h1>
                        </div>
                    <BaseInput onChange={formik.handleChange("email")}
                        onBlur={formik.handleBlur("email")}
                        value={formik.values.email}
                        placeholder={intl.formatMessage({ id: "app.register.email", defaultMessage: 'Email' })} />
                    <div className='text-red-400 mb-2'>
                        {formik.touched.email && formik.errors.email}
                    </div>

                        <div className="flex flex-row">
                            <label className={labelStyle} htmlFor="phone"><FormattedMessage id="app.register.phone" defaultMessage="Phone" /></label>
                            <h1 className='text-red-600'>*</h1>
                        </div>
                    <BaseInput onChange={formik.handleChange("phone")}
                        onBlur={formik.handleBlur("phone")}
                        value={formik.values.phone}
                        placeholder={intl.formatMessage({ id: "app.register.phone", defaultMessage: 'Phone' })} />
                    <div className='text-red-400 mb-2'>
                        {formik.touched.phone && formik.errors.phone}
                    </div>

                    <div className="grid grid-row">
                        <div className="flex flex-row">
                            <label className={labelStyle} htmlFor="password"><FormattedMessage id="app.register.password" defaultMessage="Password" /></label>
                            <h1 className='text-red-600'>*</h1>
                        </div>
                        <div className={labelLeftTextStyle}>
                            <FormattedMessage id="app.register.formik.passwordRegex" defaultMessage=""  />
                        </div>
                        <BaseInput onChange={formik.handleChange("password")}
                            onBlur={formik.handleBlur("password")}
                            value={formik.values.password}
                            placeholder={intl.formatMessage({ id: "app.register.password", defaultMessage: 'Password' })} />
                        <div className='text-red-400 mb-2'>
                            {formik.touched.password && formik.errors.password}
                        </div>

                        <div className="flex flex-row">
                            <label className={labelStyle} htmlFor="password"><FormattedMessage id="app.register.password" defaultMessage="Password" /></label>
                            <h1 className='text-red-600'>*</h1>
                        </div>

                        <BaseInput onChange={formik.handleChange("confirmPassword")}
                            onBlur={formik.handleBlur("confirmPassword")}
                            value={formik.values.confirmPassword}
                            placeholder={intl.formatMessage({ id: "app.register.confirmPassword", defaultMessage: 'Confirm Password' })} />
                        <div className='text-red-400 mb-2'>
                            {formik.touched.confirmPassword && formik.errors.confirmPassword}
                        </div>
                    </div>

                    <CategorySelect values={options} onChange={handleCategoriesChange} />
                    <div className='text-red-400 mb-2'>
                        {formik.touched.options && formik.errors.options}
                    </div>



                    <div className='row flex-row space-x-0'>
                        <div className='mr-1.5 inline '>
                            <BaseInput type="checkbox" onChange={formik.handleChange("privacy")} value={formik.values.privacy} />
                            <label className='text-red-600 ml-0.5'>*</label>
                        </div>
                        <label className={labelTextStyle}>
                            <FormattedMessage id="app.register.privacy_text" defaultMessage="" />
                        </label>
                        {(locale === 'it') ?
                            <a className={labelTextLinkStyle} href="https://marchettopellami.com/privacy-policy/#reserved_area" target="_blank">informativa del trattamento dati personali di Marchetto Pellami, a brand of AVA Leather Group Srl</a> :
                            <a className={labelTextLinkStyle} href="https://marchettopellami.com/privacy-policy/?lang=en#reserved_area" target="_blank">personal data processing policy of Marchetto Pellami, a brand of AVA Leather Group Srl</a>
                        }



                    </div>

                    <div className='row flex-row space-x-0'>
                        <div className='mr-3.5 inline '>
                            <BaseInput type="checkbox" onChange={formik.handleChange("newsletter")} value={formik.values.newsletter} />
                        </div>

                        <label className={labelStyle} htmlFor="newsletter"><FormattedMessage id="app.register.newsletter" defaultMessage="SUBSCRIBE TO THE NEWSLETTER " /></label>
                        <label className={labelTextStyle}><FormattedMessage id="app.register.newsletter_text" defaultMessage="" />
                        </label>
                        {(locale === 'it') ?
                            <a className={labelTextLinkStyle} href="https://marchettopellami.com/privacy-policy/#marketing" target="_blank">dati per la finalità di attività di marketing dell’informativa per il trattamento dei dati personali.</a>
                            :
                            <a className={labelTextLinkStyle} href="https://marchettopellami.com/privacy-policy/?lang=en#marketing" target="_blank">Privacy Policy, purpose: Direct Marketing.</a>}
                    </div>


                    {
                        !formik.isSubmitting ? (
                            <PrimaryButton type='submit'>
                                <FormattedMessage id="app.register.title" defaultMessage="Register" />
                            </PrimaryButton>
                        ) : (
                            <PrimaryButton className="flex items-center justify-center" type='submit'>
                                <TailSpin
                                    height="25"
                                    width="25"
                                    color="#fff"
                                    ariaLabel="tail-spin-loading"
                                    radius="2"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                    visible={true}
                                />
                            </PrimaryButton>)
                    }

                        <div className='text-red-600 text-xs mb-10'>
                            <FormattedMessage id="app.register.formik.fieldsRequired" defaultMessage=""  />
                        </div>

                    <FormattedMessage id="app.register.alreadyRegistered" defaultMessage="Already Registered? Login" />
                    <Link to="/app/login">
                        <button disabled={formik.isValidating} className='w-full inline-block bg-blue-900 text-center text-white font-medium rounded-xl p-2' type='submit'><FormattedMessage id="app.register.login" defaultMessage="Login" />
                        </button>
                    </Link>


                </form >
                ) : (
                    <div className='flex justify-center items-center mt-16'>
                        <div className="cols text-center place-self-center border border-green-900 py-8 px-8 rounded-md">
                            <div className="flex justify-center items-center mb-2">
                                <ThreeDots
                                    height="80"
                                    width="80"
                                    radius="9"
                                    color="#2f4d44"
                                    ariaLabel="three-dots-loading"
                                    wrapperStyle={{}}
                                    wrapperClassName=""
                                    visible={true}
                                />
                            </div>
                            <div className=""><FormattedMessage id="app.register.newAccountConfirmation" defaultMessage="Your new account Marchetto Pellami has been created.." /></div>
                            <div className="mb-10"><FormattedMessage id="app.register.newAccountCheckYourEmail" defaultMessage="Check your email inbox and click on the link to verify your email address." /></div>
                            <Link className='bg-green-900 text-white py-2 px-6 rounded hover:bg-green-800' to="/app/login"><FormattedMessage id="app.register.login" defaultMessage="Login" /></Link>
                            <div className="flex pt-12 justify-center items-center">
                                <Link to="/app/dashboard">
                                    <img className='w-24' src={homeLogo} alt="" />
                                </Link>
                            </div>
                        </div>
                    </div>
                )
            }
        </>
    );
};

export default RegisterForm;
